document.addEventListener('DOMContentLoaded', function () {
  const wrapperTitle = document.querySelectorAll('.kom-wrapper-title:not(.mobile)');
  const wrapperContent = document.querySelectorAll('.kom-wrapper-content-text:not(.mobile)');
  const wrapperTitleMobile = document.querySelectorAll('.kom-wrapper-title.mobile');
  const wrapperContentMobile = document.querySelectorAll('.kom-wrapper-content-text.mobile');
  const ancorLink = document.querySelectorAll('.kom-recensioni-ancora');

  function activateTab(index) {
    [wrapperTitle, wrapperTitleMobile].forEach(titles => {
      titles.forEach(title => title.classList.remove('kom-active'));
      if (titles[index]) titles[index].classList.add('kom-active');
    });
    [wrapperContent, wrapperContentMobile].forEach(contents => {
      contents.forEach(content => content.classList.remove('kom-active'));
      if (contents[index]) contents[index].classList.add('kom-active');
    });
  }

  wrapperTitle.forEach((title, index) => {
    title.addEventListener('click', () => activateTab(index));
  });

  wrapperTitleMobile.forEach((title, index) => {
    title.addEventListener('click', () => activateTab(index));
  });

  ancorLink.forEach((link) => {
    link.addEventListener('click', () => {
      const recensioniIndex = Array.from(wrapperTitle).findIndex(title => title.textContent.trim().toLowerCase() === 'recensioni');
      if (recensioniIndex !== -1) {
        activateTab(recensioniIndex);
      }
    });
  });
});
  function copyUrlToClipboard() {
    // Recupera l'URL della pagina corrente
    const currentUrl = window.location.href;
    
    // Usa l'API clipboard di navigator, se disponibile
    navigator.clipboard.writeText(currentUrl)
      .then(() => {
        // Facoltativo: mostra un messaggio di conferma
        alert("URL copiato negli appunti!");
      })
      .catch(err => {
        console.error("Errore nella copia negli appunti", err);
      }); 
  }; 

// document.addEventListener("DOMContentLoaded", function () {
//   const toggleButton = document.getElementById("toggleShortDescription");
//   const shortDescription = document.getElementById("shortDescription");

//   toggleButton.addEventListener("click", function () {
//     if (shortDescription.style.display === "none" || shortDescription.style.display === "") {
//       shortDescription.style.display = "block";
//       toggleButton.textContent = "Nascondi descrizione";
//     } else {
//       shortDescription.style.display = "none";
//       toggleButton.textContent = "Mostra descrizione";
//     }
//   });
// });

